import React from "react";
import { Spinner } from "react-bootstrap";

type Props = {
  variant?: string;
};

const OverlaySpinner: React.FC<Props> = (props: Props) => {
  return (
    <div className="eds-overlay-spinner">
      <Spinner
        variant={props.variant ? props.variant : "light"}
        animation="border"
        role="status"
        aria-hidden="false"
        className="fw-normal d-block mx-auto"
      />
    </div>
  );
};

export default OverlaySpinner;
